import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    accountAccessTitle: '{extraSeatLimit} account accesses',
    accountAccessUpdateDescription: {
      plural:
        'You currently pay for **{currentExtraSeats}** additional accesses with Shine {currentPlanName}. These accesses will now be included in your Shine {nextPlanName} plan.',
      singular:
        'You currently pay for **{currentExtraSeats}** additional access with Shine {currentPlanName}. This access will now be included in your Shine {nextPlanName} plan.',
    },
    accountAccessUpdateTitle: 'Access update',
    accountAccessUpdateWithExtraSeatsRemainingDescription: {
      plural:
        'You currently pay for **{currentExtraSeats}** additional accesses with Shine {currentPlanName}. **{includedAccesses}** accesses will now be included in your Shine {nextPlanName} plan.',
      singular:
        'You currently pay for **{currentExtraSeats}** additional access with Shine {currentPlanName}. **{includedAccesses}** accesses will now be included in your Shine {nextPlanName} plan.',
    },
    adjustment: {
      details:
        'Collected now. This amount corresponds to the cost of Shine {planName} for the remaining days in the current month',
      detailsSpecialOffer:
        'Collected now. This amount corresponds to the cost of Shine {planName} for the remaining period of the {trialPeriodLength} months included in your initial {initialOffer} offer.',
      title: 'Adjustment for the current month',
      titleSpecialOffer: 'Adjustment on your current offer',
    },
    faq: {
      downgrade: {
        answer:
          'Downgrading to Shine Basic costs €50 for the first 6 months, then free at the end of this period. You can go back to others plans at any time for free.',
        question: 'What if I change my mind?',
      },
      subscription: {
        answer:
          'Your subscription starts immediately if your account is already open. If not, it will start once your account is validated.',
        question: 'When does my subscription start?',
      },
    },
    free: 'Free',
    included: 'Included',
    insufficientFunds: 'Not enough funds available on your account.',
    monthlyCost: {
      description:
        'Your first payment of {amount} will be taken on {date}, then every month on the same date.',
      title: 'Monthly subscription',
      withTrialPeriod:
        'This date corresponds to the end of the remaining period of the {trialPeriodLength} months included in your initial offer.',
    },
    monthlyWithdrawal: {
      description:
        'Your first payment of {monthlyPrice} will take place on {nextBillingDate}, then every month on the same date.',
      descriptionSpecialOffer:
        'Your first payment of {monthlyPrice} will take place on {nextBillingDate}. This date corresponds to the end of the remaining period of the {trialPeriodLength} months included in your initial offer.',
      title: 'Your monthly subscription',
    },
    multiplePremiumCards: '{nbOfCards} Mastercard Business World Debit',
    next: 'Continue',
    offers: {
      capitalDeposit: 'capital deposit',
      shineStart: 'Shine Start',
    },
    pricesIndicatedWithoutVAT: 'Prices are displayed excluding taxes.',
    question: 'Have a question?',
    seeAllAdvantagesOfPlan: 'See all the avantages of Shine {planName}',
    singlePremiumCard: 'Mastercard Business World Debit',
    title: 'Choose Shine {planName}',
  },
  fr: {
    accountAccessTitle: '{extraSeatLimit} accès au compte',
    accountAccessUpdateDescription: {
      plural:
        'Vous payez **{currentExtraSeats}** accès supplémentaires avec Shine {currentPlanName}. Ces accès seront inclus avec Shine {nextPlanName}.',
      singular:
        'Vous payez **{currentExtraSeats}** accès supplémentaires avec Shine {currentPlanName}. Cet accès sera inclus avec Shine {nextPlanName}.',
    },
    accountAccessUpdateTitle: 'Mise à niveau des accès',
    accountAccessUpdateWithExtraSeatsRemainingDescription: {
      plural:
        'Vous payez **{currentExtraSeats}** accès supplémentaire avec Shine {currentPlanName}. **{includedAccesses}** accès seront inclus avec Shine {nextPlanName}.',
      singular:
        'Vous payez **{currentExtraSeats}** accès supplémentaire avec Shine {currentPlanName}. **{includedAccesses}** accès seront inclus avec Shine {nextPlanName}.',
    },
    adjustment: {
      details:
        'Prélevés dès maintenant. Ce montant correspond au coût de Shine {planName} pour les jours restants sur le mois en cours.',
      detailsSpecialOffer:
        'Prélevés dès maintenant. Ce montant correspond au coût de Shine {planName} pour la période restante sur les {trialPeriodLength} mois inclus dans votre offre {initialOffer} initiale.',
      title: 'Ajustement sur le mois en cours',
      titleSpecialOffer: 'Ajustement sur votre offre en cours',
    },
    faq: {
      downgrade: {
        answer:
          'Le retour à Shine Basic est facturé 50\u00A0€ au cours des 6 premiers mois, puis sans frais après cette période. Vous pouvez retourner aux autres plans à tout moment sans frais.',
        question: 'Est-ce que je peux changer d’avis\u00A0?',
      },
      subscription: {
        answer:
          'Votre abonnement démarre immédiatement si votre compte est déjà ouvert. Si non, il démarrera au moment de la validation de votre compte.',
        question: 'À quel moment démarre mon abonnement\u00A0?',
      },
    },
    free: 'Gratuit',
    included: 'Inclus',
    insufficientFunds: 'Vous n’avez pas les fonds suffisants sur votre compte',
    monthlyCost: {
      description:
        'Votre premier prélèvement de {amount} aura lieu le {date}, puis tous les mois à cette même date.',
      title: 'Abonnement mensuel',
      withTrialPeriod:
        'Cette date correspond à la fin de la période restante sur les {trialPeriodLength} mois inclus dans votre offre initiale.',
    },
    monthlyWithdrawal: {
      description:
        'Votre premier prélèvement de {monthlyPrice} aura lieu le {nextBillingDate}, puis tous les mois à cette même date.',
      descriptionSpecialOffer:
        'Votre premier prélèvement de {monthlyPrice} aura lieu le {nextBillingDate}. Cette date correspond à la fin de la période restante sur les {trialPeriodLength} mois inclus dans votre offre initiale.',
      title: 'Prélèvement de votre abonnement mensuel',
    },
    multiplePremiumCards: '{nbOfCards} Mastercard Business World Debit',
    next: 'Continuer',
    offers: {
      capitalDeposit: 'dépôt de capital',
      shineStart: 'Shine Start',
    },
    pricesIndicatedWithoutVAT: 'Les prix sont indiqués hors taxes.',
    question: 'Une question\u00A0?',
    seeAllAdvantagesOfPlan: 'Voir tous les avantages de Shine {planName}',
    singlePremiumCard: 'Mastercard Business World Debit',
    title: 'Choisir Shine {planName}',
  },
});

export default locales;
